<template>
  <div class="flex">
    <div class="grow"></div>
    <div class="flex-wrap" v-if="total_pages > 1">
      <button
        v-for="(page, index) in visible_pages"
        :key="index"
        class="btn min-w-14"
        :class="{
          'btn-primary': currentPage === page,
          'btn-disabled': page === '...',
        }"
        :disabled="page === '...'"
        @click="emit('page-change', Number(page))"
      >
        {{ page }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    total_pages: number;
    current_page?: number;
    pages_around_current?: number;
  }>(),
  {
    pages_around_current: 1,
  },
);

const emit = defineEmits<{ (e: "page-change", page: number): void }>();

const currentPage = computed(() => props.current_page ?? 1);

const visible_pages = computed(() => {
  const pages: (number | string)[] = [];
  const totalPages = Math.ceil(Math.max(1, props.total_pages ?? 0));
  const pagesAroundCurrent = props.pages_around_current;

  pages.push(1);

  if (currentPage.value > pagesAroundCurrent + 2) {
    pages.push("...");
  }

  const start = Math.max(2, currentPage.value - pagesAroundCurrent);
  const end = Math.min(totalPages - 1, currentPage.value + pagesAroundCurrent);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (currentPage.value < totalPages - (pagesAroundCurrent + 1)) {
    pages.push("...");
  }

  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
});
</script>
